(() => {
  const COLOR_YELLOW = "#f59e0b"; // Im Zulauf
  const COLOR_RED    = "#dc2626"; // Ausverkauft
  const COLOR_GREEN  = "#15803d"; // Sofort lieferbar
  const WEIGHT       = "600";

  // Wie lange nach Add-to-Cart-Klick/Submit NICHT auf "Ausverkauft" erzwingen (ms)
  const IGNORE_AFTER_ADD_MS = 2500;

  const SELECTOR =
    ".product__inventory, .product-inventory, .product-form__inventory, .badge--inventory, span.product-form__inventory.inventory";

  const norm = (s) =>
    (s || "")
      .toLowerCase()
      .replace(/[–—]/g, "-")
      .replace(/\s+/g, " ")
      .trim();

  const colorFromText = (text) => {
    const t = norm(text);

    if (t.includes("ausverkauft") || t.includes("nicht verfügbar") || t.includes("nicht verfuegbar")) return COLOR_RED;
    if (t.includes("im zulauf") || t.includes("lieferung in 3 bis 7 tagen")) return COLOR_YELLOW;
    if (t.includes("sofort lieferbar") || t.includes("lieferung in 1 bis 3 tagen")) return COLOR_GREEN;

    return "";
  };

  const getAddToCartButton = (form) => {
    return (
      form.querySelector('button[type="submit"][name="add"]') ||
      form.querySelector('button[type="submit"]') ||
      form.querySelector('[data-action="add-to-cart"]')
    );
  };

  // Viele Themes setzen beim Klick kurz "loading" / aria-busy etc.
  const isLoadingButton = (btn) => {
    if (!btn) return false;
    const cls = btn.classList;
    return (
      btn.getAttribute("aria-busy") === "true" ||
      btn.dataset.loading === "true" ||
      btn.getAttribute("data-loading") === "true" ||
      btn.dataset.state === "loading" ||
      cls.contains("loading") ||
      cls.contains("is-loading") ||
      cls.contains("button--loading") ||
      cls.contains("btn--loading")
    );
  };

  const markIgnoreSoldOut = (form) => {
    if (!form) return;
    form.dataset.ihIgnoreSoldOutUntil = String(Date.now() + IGNORE_AFTER_ADD_MS);
  };

  const shouldIgnoreSoldOut = (form) => {
    if (!form) return false;
    const until = parseInt(form.dataset.ihIgnoreSoldOutUntil || "0", 10) || 0;
    if (!until) return false;

    if (Date.now() >= until) {
      delete form.dataset.ihIgnoreSoldOutUntil;
      return false;
    }
    return true;
  };

  const apply = () => {
    const els = document.querySelectorAll(SELECTOR);
    if (!els.length) return;

    els.forEach((el) => {
      const form = el.closest("form.product-form");
      const isProductForm = !!form;

      if (isProductForm) {
        const btn = getAddToCartButton(form);

        // Wenn gerade frisch geklickt/submitted: NICHT auf "Ausverkauft" erzwingen
        const ignore = shouldIgnoreSoldOut(form);

        // Falls wir vorher mal überschrieben hatten, jetzt sofort zurücksetzen
        if (ignore && el.textContent.trim() === "Ausverkauft" && el.dataset.ihPrevText) {
          el.textContent = el.dataset.ihPrevText;
          delete el.dataset.ihPrevText;
        }

        const notBuyable =
          !ignore &&
          btn &&
          !isLoadingButton(btn) && // Loading ist NICHT gleich Ausverkauft
          (btn.disabled === true ||
            btn.getAttribute("aria-disabled") === "true" ||
            btn.classList.contains("button--disabled") ||
            btn.classList.contains("is-disabled") ||
            btn.classList.contains("disabled"));

        if (notBuyable) {
          if (!el.dataset.ihPrevText) el.dataset.ihPrevText = el.textContent.trim();
          if (el.textContent.trim() !== "Ausverkauft") el.textContent = "Ausverkauft";
          el.style.color = COLOR_RED;
          el.style.fontWeight = WEIGHT;
          return;
        } else {
          if (el.textContent.trim() === "Ausverkauft" && el.dataset.ihPrevText) {
            el.textContent = el.dataset.ihPrevText;
            delete el.dataset.ihPrevText;
          }
        }
      }

      const c = colorFromText(el.textContent);
      if (c) el.style.color = c;
      el.style.fontWeight = WEIGHT;
    });
  };

  let scheduled = false;
  const scheduleApply = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  };

  const boot = () => {
    scheduleApply();

    // Alle Produkt-Forms abdecken (nicht nur die erste)
    document.querySelectorAll("form.product-form").forEach((form) => {
      const btn = getAddToCartButton(form);

      // Beim Klick/Submit kurz "Ausverkauft erzwingen" unterdrücken
      if (btn) {
        btn.addEventListener(
          "click",
          () => {
            markIgnoreSoldOut(form);
            scheduleApply();
          },
          true
        );
      }

      form.addEventListener(
        "submit",
        () => {
          markIgnoreSoldOut(form);
          scheduleApply();
        },
        true
      );

      // Variant-Wechsel etc.
      form.addEventListener("change", scheduleApply);
      form.addEventListener("click", scheduleApply);
    });

    document.addEventListener("variant:change", scheduleApply);
    document.addEventListener("variant:changed", scheduleApply);
    document.addEventListener("shopify:section:load", scheduleApply);
  };

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
})();